const nav = [
    {
        title: "Home",
        link: "/"
    },
    {
        title: "Team",
        link: "/team"
    },
    {
        title: "Events",
        link: "/events"
    },
    {
        title: "Join Us",
        link: "/joinus"
    }
]

export default nav;